import React, { useRef } from "react";
import useWindowDimensions from "../hooks/useWindowDimensions";
import { useTheme } from '@material-ui/core/styles';
import auth from "../auth";
import Version from "version";
import { useConnect } from 'dotnetify';
import { Grid } from '@material-ui/core';
import SparkleDialog from '../controls/components/SparkleDialog';
import TopContainer from '../controls/TopContainer';
import { Box, BoxTitle, BoxContent } from '../controls/Box';
import { SmallButton } from '../controls/components/Buttons';
import { Link } from 'react-tiger-transition';
import Phone from 'assets/img/Phone.png';
import SimCard from 'assets/img/svg/simcard.svg';
import KraftriketLogo from 'assets/img/Kraftriket logo.png';
export default function Shopping() {
    const { vm, state } = useConnect("Shopping", {}, {
        headers: {
            Authorization: "Bearer " + auth.getAccessToken(),
            ClientVersion: Version.getVersion(),
            ServerToken: window.sessionStorage.ServerToken
        },
        exceptionHandler: _ => auth.signOut()
    });
    const wDim = useWindowDimensions();
    const theme = useTheme();
    const dialogRef = useRef();
    const handleRefresh = () => {
        vm.$dispatch({ Refresh: true });
    }
    return (
        <>
            <SparkleDialog ref={dialogRef} handleRefresh={handleRefresh} />
            <TopContainer title={state.IsNorway ? 'Handle' : 'Handla'} hideprofile={state.WebShopOpen && !wDim.desktop}>
                <>
                    {state.WebShopOpen &&
                        <Box background>
                            <BoxTitle primaryColor>
                            {state.IsNorway ? 'Ny mobil? Se nettbutikken' : 'Ny mobil? Se vår nätbutik'}
                </BoxTitle>
                            <BoxContent>
                                <Grid container direction="row">
                                    <div style={{ width: '70%' }}>
                                    {state.IsNorway ? 'Se både nye mobiler, lite brukte mobiler og tilbehør i vår nye nettbutikk.' : 'Du hittar både nya modeller och begagnade mobiler och tillbehör i vår nya nätbutik.'}
                                    </div>
                                    <div style={{ position: 'relative' }}>
                                        <img src={Phone} alt="" style={{ position: 'absolute', left: '10px', top: '-120px' }} />
                                    </div>
                                </Grid>
                            </BoxContent>
                        <SmallButton onClick={() => { dialogRef.current.openUrl(state.IsNorway ? 'https://nettbutikk.chilimobil.no/mobiltelefoner' : 'https://shop.chilimobil.se'); }}>{state.IsNorway ? 'Gå til nettbutikk' : 'Till nätbutiken'}</SmallButton>
                        </Box>
                    }
                    {state.KraftriketUrl &&
                    <>
                        <div style={{ marginBottom: '10px' }}>Strøm</div>
                        <Box background>
                            <BoxTitle>
                                Strøm + mobil = enda billigere
                            </BoxTitle>
                            <BoxContent>
                                <Grid container direction="row" justify="space-between" alignItems="center" style={{ paddingBottom: '10px' }}>
                                    <Grid item xs={8}>
                                        Siden du er Chilimobil-kunde får du nå noen av markedets beste priser på strøm fra Kraftriket.
                                    </Grid>
                                    <Grid item xs={4} style={{ textAlign: 'center' }}>
                                        <img src={KraftriketLogo} alt="" width={80} style={{ marginLeft: '10px', marginBottom: '-30px', borderRadius: '10px' }}/>
                                    </Grid>
                                </Grid>
                            </BoxContent>
                            <SmallButton onClick={() => { dialogRef.current.openUrl(state.KraftriketUrl, true); }}>Les mer</SmallButton>
                        </Box>                    
                    </>
                    }
                    <>
                        <div style={{ marginBottom: '10px' }}>{state.IsNorway ? 'Mobilabonnement' : 'Mobilabonnemang'}</div>
                        <Grid container direction="row" justify="space-between">
                            {state.IsPostpaid && !state.IsData &&
                                <Box background>
                                    <BoxTitle>
                                        {state.IsNorway ? "Endre abonnement" : "Byt abonnemangsform"}
                                    </BoxTitle>
                                    <BoxContent>
                                        <Grid container direction="row" justify="space-between" alignItems="center">
                                            <Grid item xs={8}>
                                                {state.IsNorway ? state.IsPrepaid ? 'Du kan enkelt gjøre endringer på ditt kontantkort her.' : 'Du kan enkelt gjøre endringer på ditt abonnement her.' : 'Du kan enkelt ändringar på ditt abonnemang här.'}
                                            </Grid>
                                            <Grid item xs={4} style={{ textAlign: 'center' }}>
                                                <div style={{ fontFamily: theme.typography.fontFamily, fontStyle: 'normal', fontVariant: 'normal', fontWeight: 400, fontSize: '14px' }}>
                                                    {state.Subscription.packageName}
                                                </div>
                                                <div>{state.IsNorway ? 'Nåværende' : 'Nuvarande'}</div>
                                            </Grid>
                                        </Grid>
                                    </BoxContent>
                                    <SmallButton onClick={() => { dialogRef.current.showDialog('changeSubscription'); }}>{state.IsNorway ? 'Endre' : 'Byt'}</SmallButton>
                                </Box>
                            }
                            {state.WebOrderUrl &&
                                <Box background>
                                    <BoxTitle>
                                        {state.IsNorway ? "Bestill abonnement" : "Beställ abonnemang"}
                                    </BoxTitle>
                                    <BoxContent>
                                        <Grid container direction="row" justify="space-between" alignItems="center">
                                            <Grid item xs={8}>
                                                {state.IsNorway ? 'Nytt nummer, eller flytte et nummer fra et annet mobilselskap?' : 'Nytt nummer, eller flytta ett nummer från en annan mobiloperatör?'}
                                            </Grid>
                                            <Grid item xs={4} style={{ textAlign: 'center' }}>
                                                <img src={SimCard} height="75" alt="" style={{ transform: 'rotate(14deg)', margin: '-20px' }} />
                                            </Grid>
                                        </Grid>
                                    </BoxContent>
                                    <SmallButton onClick={() => { dialogRef.current.openUrl(state.WebOrderUrl); }}>{state.IsNorway ? 'Bestill' : 'Beställ'}</SmallButton>
                                </Box>
                            }
                        </Grid>
                        {state.WebOrderUrlMBB &&
                            <>
                            <div style={{ marginBottom: '10px' }}>{state.IsNorway ? 'Bredbånd' : 'Bredband'}</div>
                                <Grid container direction="row" justify="space-between">
                                    {state.WebOrderUrlMBB &&
                                        <Box background>
                                            <BoxTitle>
                                                {state.IsNorway ? "Hyttebredbånd" : "Mobilt bredband"}
                                            </BoxTitle>
                                            <BoxContent>
                                        <Grid container direction="row" justify="space-between" alignItems="center" style={{ marginBottom: '10px' }}>
                                                    <Grid item xs={8}>
                                                        {state.IsNorway ? 'Bredbåndet som passer perfekt for hytte og fritidsboliger. Du slipper å overbetale når du ikke er på hytten.' : ''}
                                                    </Grid>
                                                    <Grid item xs={4} style={{ textAlign: 'center' }}>
                                                        <div style={{ fontFamily: theme.typography.fontFamily, fontStyle: 'normal', fontVariant: 'normal', fontWeight: 400, fontSize: '14px' }}>Fra 299,-</div>
                                                        <div style={{ fontSize: '12px' }}>Følger forbruket</div>
                                                    </Grid>
                                                </Grid>
                                            </BoxContent>
                                            <SmallButton onClick={() => { dialogRef.current.openUrl(state.WebOrderUrlMBB); }}>{state.IsNorway ? 'Bestill' : 'Beställ'}</SmallButton>
                                        </Box>
                                    }

                                </Grid>
                            </>
                        }
                        {state.Services?.length > 0 &&
                            <>
                            <div style={{ marginBottom: '10px' }}>{state.IsNorway ? 'Tjenester' : 'Tjänster'}</div>
                                <Grid container direction="row" justify="space-between">
                                    {state.Services?.map((service, index) => {
                                        return (
                                            <Box key={index} background>
                                                <BoxTitle>
                                                    {service.Title}
                                                </BoxTitle>
                                                <BoxContent>
                                                    <Grid container direction="row" justify="space-between" alignItems="center">
                                                        <Grid item xs={7}>

                                                        </Grid>
                                                        <Grid item xs={5} style={{ textAlign: 'center' }}>
                                                            <div style={{ fontFamily: theme.typography.fontFamily, fontStyle: 'normal', fontVariant: 'normal', fontWeight: 400, fontSize: '14px' }}>Etablering: {service.InitialFee}</div>
                                                            <div style={{ fontSize: '12px' }}>{service.MonthlyFee} per mnd.</div>
                                                        </Grid>
                                                    </Grid>
                                                </BoxContent>
                                                <SmallButton onClick={() => { sessionStorage.ServiceNo = service.ProductNo; dialogRef.current.showDialog('changeService'); }}>{state.IsNorway ? 'Kjøp' : 'Beställ'}</SmallButton>
                                            </Box>
                                        )
                                    })}
                                </Grid>
                            </>
                        }
                    </>
                </>
            </TopContainer>
        </>
    );
}